import { notification } from 'antd';
import type {
  DifficultyDistributionModelCode,
  ScheduleConfiguration,
  ScheduleConfigurationPrePublishCheckDto,
  ScheduleConfigurationsListRequest,
  ScheduleConstraint,
  ScheduleConstraintCategory,
} from './types';
import type { ListResponseWithPagination } from '../types';
import { appApi } from '../api-instance';

export const getScheduleConfigurations = (
  params: ScheduleConfigurationsListRequest = {},
): Promise<ListResponseWithPagination<ScheduleConfiguration>> => {
  return appApi
    .get('/schedule-configurations', {
      params,
      paramsSerializer: { indexes: null },
    })
    .then((res) => res.data)
    .catch((error) => {
      notification.error({ message: 'Не удалось загрузить конфигурации расписания' });
      throw error;
    });
};

export const getScheduleConfigurationById = (id: number): Promise<ScheduleConfiguration> => {
  return appApi
    .get(`/schedule-configurations/${id}`)
    .then((res) => res.data)
    .catch((error) => {
      notification.error({ message: 'Не удалось загрузить конфигурацию расписания' });
      throw error;
    });
};

export const createScheduleConfiguration = (
  scheduleConfiguration: ScheduleConfiguration,
): Promise<ScheduleConfiguration> => {
  return appApi
    .post('/schedule-configurations', scheduleConfiguration)
    .then((res) => res.data)
    .catch((error) => {
      notification.error({ message: 'Не удалось создать конфигурацию расписания' });
      throw error;
    });
};

export const updateScheduleConfiguration = (
  id: number,
  scheduleConfiguration: ScheduleConfiguration,
): Promise<ScheduleConfiguration> => {
  return appApi
    .put(`/schedule-configurations/${id}`, scheduleConfiguration)
    .then((res) => res.data)
    .catch((error) => {
      notification.error({ message: 'Не удалось обновить конфигурацию расписания' });
      throw error;
    });
};

export const deleteScheduleConfiguration = (id: number): Promise<void> => {
  return appApi
    .delete(`/schedule-configurations/${id}`)
    .then((res) => res.data)
    .catch((error) => {
      notification.error({ message: 'Не удалось удалить конфигурацию расписания' });
      throw error;
    });
};

export const publishScheduleConfiguration = (id: number): Promise<void> => {
  return appApi
    .post(`/schedule-configurations/${id}/publish`)
    .then((res) => res.data)
    .catch((error) => {
      notification.error({ message: 'Не удалось опубликовать конфигурацию расписания' });
      throw error;
    });
};

export const getScheduleFile = (configurationId: string, timetableId: string): Promise<Blob> => {
  return appApi
    .get<Blob>(
      `/schedule-configurations/${configurationId}/timetables/${timetableId}/export/xlsx`,
      { responseType: 'blob' },
    )
    .then((res) => res.data)
    .catch((error) => {
      notification.error({ message: 'Не удалось загрузить файл расписания' });
      throw error;
    });
};

export const getScheduleConstraints = (
  category?: ScheduleConstraintCategory,
): Promise<ScheduleConstraint[]> => {
  return appApi
    .get(`/schedule-configurations/constraints`, {
      params: {
        category,
      },
    })
    .then((res) => res.data)
    .catch((error) => {
      notification.error({ message: 'Не удалось загрузить конфигурацию расписания' });
      throw error;
    });
};

export const refineScheduleConfiguration = ({
  configurationId,
  timetableId,
  constraints,
  difficultyDistributionModelCode,
}: {
  configurationId: string;
  timetableId: string;
  constraints: ScheduleConstraint[];
  difficultyDistributionModelCode: DifficultyDistributionModelCode | null;
}): Promise<void> => {
  return appApi
    .post(`/schedule-configurations/${configurationId}/timetables/${timetableId}/refine`, {
      constraints,
      difficultyDistributionModelCode,
    })
    .then((res) => res.data)
    .catch((error) => {
      notification.error({ message: 'Не удалось достроить конфигурацию расписания' });
      throw error;
    });
};

export const prePublishCheckScheduleConfiguration = (
  configurationId: number,
): Promise<ScheduleConfigurationPrePublishCheckDto[]> => {
  return appApi
    .get(`/schedule-configurations/${configurationId}/pre-publish-check`)
    .then((res) => res.data)
    .catch((error) => {
      notification.error({
        message: 'Не удалось выполнить проверку конфигурации перед публикацией',
      });
      throw error;
    });
};
